// https://wiki-en.genealogy.net/GEDCOM-Tags
/**
 * All the standard Gedcom tags.
 */
export var Tag;
(function (Tag) {
    Tag["Abbreviation"] = "ABBR";
    Tag["Address"] = "ADDR";
    Tag["Address1"] = "ADR1";
    Tag["Address2"] = "ADR2";
    Tag["Address3"] = "ADR3";
    Tag["Adoption"] = "ADOP";
    Tag["AdultChristening"] = "CHRA";
    Tag["Age"] = "AGE";
    Tag["Agency"] = "AGNC";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["Alias"] = "ALIA";
    Tag["Ancestors"] = "ANCE";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["AncestorInterest"] = "ANCI";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["AncestralFileNumber"] = "AFN";
    Tag["Annulment"] = "ANUL";
    Tag["Associates"] = "ASSO";
    Tag["Author"] = "AUTH";
    Tag["Baptism"] = "BAPM";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["BaptismLDS"] = "BAPL";
    Tag["BarMitzvah"] = "BARM";
    Tag["BatMitzvah"] = "BASM";
    Tag["BinaryObject"] = "BLOB";
    Tag["Birth"] = "BIRT";
    Tag["Blessing"] = "BLES";
    Tag["Burial"] = "BURI";
    Tag["CallNumber"] = "CALN";
    Tag["Caste"] = "CAST";
    Tag["Cause"] = "CAUS";
    Tag["Census"] = "CENS";
    Tag["Change"] = "CHAN";
    Tag["Character"] = "CHAR";
    Tag["Child"] = "CHIL";
    Tag["ChildrenCount"] = "NCHI";
    Tag["Christening"] = "CHR";
    Tag["City"] = "CITY";
    Tag["Concatenation"] = "CONC";
    Tag["Confirmation"] = "CONF";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["ConfirmationLDS"] = "CONL";
    Tag["Continuation"] = "CONT";
    Tag["Copyright"] = "COPR";
    Tag["Corporate"] = "CORP";
    Tag["Country"] = "CTRY";
    Tag["Cremation"] = "CREM";
    Tag["Data"] = "DATA";
    Tag["Date"] = "DATE";
    Tag["Death"] = "DEAT";
    Tag["Descendants"] = "DESC";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["DescendantInt"] = "DESI";
    Tag["Destination"] = "DEST";
    Tag["Divorce"] = "DIV";
    Tag["DivorceFiled"] = "DIVF";
    Tag["Education"] = "EDUC";
    Tag["Email"] = "EMAIL";
    Tag["Emigration"] = "EMIG";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["Endowment"] = "ENDL";
    Tag["Engagement"] = "ENGA";
    Tag["Event"] = "EVEN";
    Tag["Fact"] = "FACT";
    Tag["Family"] = "FAM";
    Tag["FamilyChild"] = "FAMC";
    Tag["FamilyFile"] = "FAMF";
    Tag["FamilySpouse"] = "FAMS";
    Tag["Fax"] = "FAX";
    Tag["File"] = "FILE";
    Tag["FirstCommunion"] = "FCOM";
    Tag["Format"] = "FORM";
    Tag["Gedcom"] = "GEDC";
    Tag["GivenName"] = "GIVN";
    Tag["Graduation"] = "GRAD";
    Tag["Header"] = "HEAD";
    Tag["Husband"] = "HUSB";
    Tag["IdentificationNumber"] = "IDNO";
    Tag["Immigration"] = "IMMI";
    Tag["Individual"] = "INDI";
    Tag["Language"] = "LANG";
    Tag["Latitude"] = "LATI";
    Tag["Legatee"] = "LEGA";
    Tag["Longitude"] = "LONG";
    Tag["Map"] = "MAP";
    Tag["Marriage"] = "MARR";
    Tag["MarriageBan"] = "MARB";
    Tag["MarriageContract"] = "MARC";
    Tag["MarriageCount"] = "NMR";
    Tag["MarriageLicense"] = "MARL";
    Tag["MarriageSettlement"] = "MARS";
    Tag["Media"] = "MEDI";
    Tag["Name"] = "NAME";
    Tag["NamePrefix"] = "NPFX";
    Tag["NameSuffix"] = "NSFX";
    Tag["Nationality"] = "NATI";
    Tag["Naturalization"] = "NATU";
    Tag["Nickname"] = "NICK";
    Tag["Note"] = "NOTE";
    Tag["Object"] = "OBJE";
    Tag["Occupation"] = "OCCU";
    Tag["Ordinance"] = "ORDI";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["Ordination"] = "ORDN";
    Tag["Page"] = "PAGE";
    Tag["Pedigree"] = "PEDI";
    Tag["Phone"] = "PHON";
    Tag["Phonetic"] = "FONE";
    Tag["PhysicalDescription"] = "DSCR";
    Tag["Place"] = "PLAC";
    Tag["PostalCode"] = "POST";
    Tag["Probate"] = "PROB";
    Tag["Property"] = "PROP";
    Tag["Publication"] = "PUBL";
    Tag["QualityOfData"] = "QUAY";
    Tag["RecordFileNumber"] = "RFN";
    Tag["RecordIdNumber"] = "RIN";
    Tag["Reference"] = "REFN";
    Tag["Relationship"] = "RELA";
    Tag["Religion"] = "RELI";
    Tag["Repository"] = "REPO";
    Tag["Residence"] = "RESI";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["Restriction"] = "RESN";
    Tag["Retirement"] = "RETI";
    Tag["Role"] = "ROLE";
    Tag["Romanized"] = "ROMN";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["SealingChild"] = "SLGC";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["SealingSpouse"] = "SLGS";
    Tag["Sex"] = "SEX";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["SocialSecurityNumber"] = "SSN";
    Tag["Source"] = "SOUR";
    Tag["State"] = "STAE";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["Status"] = "STAT";
    /**
     * Obsoleted in Gedcom 5.5.5
     */
    Tag["Submission"] = "SUBN";
    Tag["Submitter"] = "SUBM";
    Tag["Surname"] = "SURN";
    Tag["SurnamePrefix"] = "SPFX";
    Tag["Temple"] = "TEMP";
    Tag["Text"] = "TEXT";
    Tag["Time"] = "TIME";
    Tag["Title"] = "TITL";
    Tag["Trailer"] = "TRLR";
    Tag["Type"] = "TYPE";
    Tag["Version"] = "VERS";
    Tag["Web"] = "WWW";
    Tag["Wife"] = "WIFE";
    Tag["Will"] = "WILL";
})(Tag || (Tag = {}));
//# sourceMappingURL=Tag.js.map